import { INavData } from '../coreui/sidebar';

export const WalkAndWinNavItems: INavData[] = [
  {
    name: 'DASHBOARD.DASHBOARD',
    url: '/dashboard',
    icon: 'sli-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Walk and win Manager' 
  },
      {
        name: 'Competitions List',
        url: '/competition',
        icon: 'sli-event'
      },
      {
        name: 'Members List',
        url: '/members',
        icon: 'cil-running'
      },
      {
        name: 'Gifts List',
        url: '/gifts',
        icon: 'sli-calendar'
      },
      {
        name: 'DASHBOARD.CATEGORIES',
        url: '/categories',
        icon: 'sli-film'
      },
      {
   
        name: 'DASHBOARD.ARTICLES',
        url: '/articles',
        icon: 'cil-short-text'
      },
      {
   
        name: 'DASHBOARD.APPLICATIONS',
        url: '/applications',
        icon: 'cil-short-text',
      },
      {
   
        name: 'Recettes',
        url: '/recipes',
        icon: 'cil-short-text'
      },
       {
   
        name: 'CGU',
        url: '/cgu',
        icon: 'cil-short-text'
      },
      
      {
   
        name: 'Top 50',
        url: '/list',
        icon: 'cil-short-text'
      },
      {
   
        name: 'Location',
        url: '/location',
        icon: 'cil-short-text'
      },

      {
   
        name: 'Statistics',
        url: '/statistics',
        icon: 'cil-short-text'
      },

      {
   
        name: 'Ingredients',
        url: '/ingredients',
        icon: 'cil-short-text'
      },

      {
   
        name: 'steps recettes ',
        url: '/steps',
        icon: 'cil-short-text'
      },

      {
   
        name: 'Videos ',
        url: '/videos',
        icon: 'cil-short-text'
      },
      {
   
        name: 'Quizzs ',
        url: '/quizzes',
        icon: 'cil-short-text'
      },
       {
   
        name: 'Notifications ',
        url: '/notifications',
        icon: 'cil-short-text'
      },
     

 
];

